// @ts-nocheck

import * as Apollo from "@apollo/client";

import gql from "graphql-tag";
import * as APITypes from "../../apiTypes";

const defaultOptions = {} as const;
export type GetCalendarAvailabilityQueryVariables = APITypes.Exact<{
  data: APITypes.GetAvailabilityCalendarForReservationInput;
}>;

export type GetCalendarAvailabilityQuery = {
  generateAvailabilityCalendarForReservation: Array<{
    slotDate?: string | null;
    slots?: Array<{ startTime?: string | null }> | null;
  }>;
};

export type CreateWorkerDayOffMutationVariables = APITypes.Exact<{
  data: APITypes.CreateWorkerDayOffInput;
}>;

export type CreateWorkerDayOffMutation = { createWorkerDayOff: boolean };

export type DeleteWorkerDayOffMutationVariables = APITypes.Exact<{
  data: APITypes.DeleteWorkerDayOffInput;
}>;

export type DeleteWorkerDayOffMutation = { deleteWorkerDayOff: boolean };

export type UpdateWorkerCalendarMutationVariables = APITypes.Exact<{
  data: APITypes.UpdateWorkerCalendarInput;
}>;

export type UpdateWorkerCalendarMutation = { updateWorkerCalendar: boolean };

export const GetCalendarAvailabilityDocument = gql`
    query GetCalendarAvailability($data: GetAvailabilityCalendarForReservationInput!) {
  generateAvailabilityCalendarForReservation(data: $data) {
    slotDate
    slots {
      startTime
    }
  }
}
    `;

/**
 * __useGetCalendarAvailabilityQuery__
 *
 * To run a query within a React component, call `useGetCalendarAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalendarAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCalendarAvailabilityQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetCalendarAvailabilityQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCalendarAvailabilityQuery,
    GetCalendarAvailabilityQueryVariables
  > &
    ({ variables: GetCalendarAvailabilityQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCalendarAvailabilityQuery, GetCalendarAvailabilityQueryVariables>(
    GetCalendarAvailabilityDocument,
    options,
  );
}
export function useGetCalendarAvailabilityLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCalendarAvailabilityQuery,
    GetCalendarAvailabilityQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCalendarAvailabilityQuery, GetCalendarAvailabilityQueryVariables>(
    GetCalendarAvailabilityDocument,
    options,
  );
}
export function useGetCalendarAvailabilitySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCalendarAvailabilityQuery,
        GetCalendarAvailabilityQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetCalendarAvailabilityQuery,
    GetCalendarAvailabilityQueryVariables
  >(GetCalendarAvailabilityDocument, options);
}
export type GetCalendarAvailabilityQueryHookResult = ReturnType<
  typeof useGetCalendarAvailabilityQuery
>;
export type GetCalendarAvailabilityLazyQueryHookResult = ReturnType<
  typeof useGetCalendarAvailabilityLazyQuery
>;
export type GetCalendarAvailabilitySuspenseQueryHookResult = ReturnType<
  typeof useGetCalendarAvailabilitySuspenseQuery
>;
export type GetCalendarAvailabilityQueryResult = Apollo.QueryResult<
  GetCalendarAvailabilityQuery,
  GetCalendarAvailabilityQueryVariables
>;
export const CreateWorkerDayOffDocument = gql`
    mutation CreateWorkerDayOff($data: CreateWorkerDayOffInput!) {
  createWorkerDayOff(data: $data)
}
    `;
export type CreateWorkerDayOffMutationFn = Apollo.MutationFunction<
  CreateWorkerDayOffMutation,
  CreateWorkerDayOffMutationVariables
>;

/**
 * __useCreateWorkerDayOffMutation__
 *
 * To run a mutation, you first call `useCreateWorkerDayOffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkerDayOffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkerDayOffMutation, { data, loading, error }] = useCreateWorkerDayOffMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateWorkerDayOffMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateWorkerDayOffMutation,
    CreateWorkerDayOffMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateWorkerDayOffMutation, CreateWorkerDayOffMutationVariables>(
    CreateWorkerDayOffDocument,
    options,
  );
}
export type CreateWorkerDayOffMutationHookResult = ReturnType<typeof useCreateWorkerDayOffMutation>;
export type CreateWorkerDayOffMutationResult = Apollo.MutationResult<CreateWorkerDayOffMutation>;
export type CreateWorkerDayOffMutationOptions = Apollo.BaseMutationOptions<
  CreateWorkerDayOffMutation,
  CreateWorkerDayOffMutationVariables
>;
export const DeleteWorkerDayOffDocument = gql`
    mutation DeleteWorkerDayOff($data: DeleteWorkerDayOffInput!) {
  deleteWorkerDayOff(data: $data)
}
    `;
export type DeleteWorkerDayOffMutationFn = Apollo.MutationFunction<
  DeleteWorkerDayOffMutation,
  DeleteWorkerDayOffMutationVariables
>;

/**
 * __useDeleteWorkerDayOffMutation__
 *
 * To run a mutation, you first call `useDeleteWorkerDayOffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkerDayOffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkerDayOffMutation, { data, loading, error }] = useDeleteWorkerDayOffMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeleteWorkerDayOffMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteWorkerDayOffMutation,
    DeleteWorkerDayOffMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteWorkerDayOffMutation, DeleteWorkerDayOffMutationVariables>(
    DeleteWorkerDayOffDocument,
    options,
  );
}
export type DeleteWorkerDayOffMutationHookResult = ReturnType<typeof useDeleteWorkerDayOffMutation>;
export type DeleteWorkerDayOffMutationResult = Apollo.MutationResult<DeleteWorkerDayOffMutation>;
export type DeleteWorkerDayOffMutationOptions = Apollo.BaseMutationOptions<
  DeleteWorkerDayOffMutation,
  DeleteWorkerDayOffMutationVariables
>;
export const UpdateWorkerCalendarDocument = gql`
    mutation UpdateWorkerCalendar($data: UpdateWorkerCalendarInput!) {
  updateWorkerCalendar(data: $data)
}
    `;
export type UpdateWorkerCalendarMutationFn = Apollo.MutationFunction<
  UpdateWorkerCalendarMutation,
  UpdateWorkerCalendarMutationVariables
>;

/**
 * __useUpdateWorkerCalendarMutation__
 *
 * To run a mutation, you first call `useUpdateWorkerCalendarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkerCalendarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkerCalendarMutation, { data, loading, error }] = useUpdateWorkerCalendarMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateWorkerCalendarMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateWorkerCalendarMutation,
    UpdateWorkerCalendarMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateWorkerCalendarMutation, UpdateWorkerCalendarMutationVariables>(
    UpdateWorkerCalendarDocument,
    options,
  );
}
export type UpdateWorkerCalendarMutationHookResult = ReturnType<
  typeof useUpdateWorkerCalendarMutation
>;
export type UpdateWorkerCalendarMutationResult =
  Apollo.MutationResult<UpdateWorkerCalendarMutation>;
export type UpdateWorkerCalendarMutationOptions = Apollo.BaseMutationOptions<
  UpdateWorkerCalendarMutation,
  UpdateWorkerCalendarMutationVariables
>;
